<template>
    <svg
        width="14"
        height="14"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g :fill="customColor">
            <path d="M8 0a5.15 5.15 0 0 0-5.156 5.156c0 1.1.33 2.081.965 3l3.796 5.925a.47.47 0 0 0 .79 0l3.813-5.945c.62-.877.948-1.908.948-2.98A5.16 5.16 0 0 0 8 0m0 7.5a2.346 2.346 0 0 1-2.344-2.344A2.346 2.346 0 0 1 8 2.813a2.347 2.347 0 0 1 2.344 2.343A2.347 2.347 0 0 1 8 7.5" />
            <path d="m11.665 10.772-2.36 3.69a1.55 1.55 0 0 1-2.61 0l-2.364-3.69C2.251 11.255.97 12.136.97 13.188.969 15.015 4.592 16 8 16s7.031-.986 7.031-2.812c0-1.054-1.284-1.936-3.367-2.416" />
        </g>
        <defs>
            <clipPath>
                <path
                    fill="#fff"
                    d="M0 0h16v16H0z"
                />
            </clipPath>
        </defs>
    </svg>
</template>
<script setup lang="ts">
    import { DEFAULT_BUTTON_COLOR } from '~/utils/constants';

    defineProps({
        customColor: {
            type: String,
            required: false,
            default: DEFAULT_BUTTON_COLOR
        }
    });
</script>
